var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCause4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 248.73 122.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#1a1692;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.09,39.13C5.42,37.39,52.59,2.45,54.92,1.86S70.06-.47,71.81.12s4.66,7.57,4.66,7.57l-21.55,7L3.67,62.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.49,49.83c3.13-.88,24.13-1.32,30.83-.44S85.22,70.6,85.22,70.6l3.57,7.51s-38,9.72-48.25,9.28S14.62,70.6,13.73,69.28,32.49,49.83,32.49,49.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.24,54.59a11.12,11.12,0,0,0-6.72,3c-5.24,4.85-5.58,14-.91,19.36,6.22,7.23,20.27,6.68,24-2.85S43.72,53.83,34.24,54.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.3,69.9c3.13-.88,24.12-1.33,30.83-.44S182,90.66,182,90.66l3.58,7.51s-38,9.72-48.25,9.28-25.91-16.79-26.8-18.11S129.3,69.9,129.3,69.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M121.87,85.73a13.67,13.67,0,0,0,18.48,15,17.46,17.46,0,0,0,6.21-4.39,12.17,12.17,0,0,0,2.94-4.71C154.65,74.17,124.38,70.73,121.87,85.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.93,39.25,3.17,41.4,0,91.21l78.93,11.21,6.86-58.68Zm-22,42.34,2.4-32.45,58,3.5-2.44,37.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.55,54.88,107.43,52,99.06,106.7,182,122.06Zm-13.28,54.84-60.58-10,4.25-33.9,58.49,3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.61,69.52c1.63,0,28.19,1.62,28.19,1.62s-1.08,21.69-1.08,20.06-30.9-6.5-29.82-8.13S79.61,69.52,79.61,69.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.43,56.07c2.17-1.62,46.08-34.15,48.25-34.69s14.09-2.17,15.72-1.62,4.33,7,4.33,7l-20,6.51L181,77.75Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCause4);
export default __webpack_public_path__ + "static/media/cause_4.067d16c0f01135173d93a807620a9b8a.svg";
export { ForwardRef as ReactComponent };